<template>
    <div class="ls-manual-request__container grid">
        <div class="grid__col-12">
            <slot></slot>
        </div>
        <div class="grid">
            <div class="grid__col-12">
                <h2 class="ls-condensed" :class="{ 'ls-manual-request--mq-invalid': mqInvalid }">
                    What services are you interested in?
                </h2>
            </div>
            <div class="grid__col-xs-12 grid__col-sm-10">
                <div class="ls-services__outer-container">
                    <div
                        v-for="(service, idx) in services"
                        :key="service.property"
                        class="ls-services__inner-container ls-margin--top"
                    >
                        <a
                            v-if="service.replaceCheckbox"
                            class="ls-button ls-button--block"
                            @click.prevent="$router.go(-1)"
                        >
                            {{ service.name }}
                        </a>
                        <label
                            v-else
                            class="ls-button ls-button--block ls-button--checkbox"
                            :class="{
                                'ls-button--green ls-button--faded': service.value,
                            }"
                        >
                            <input
                                v-model="service.value"
                                type="checkbox"
                                @change="updateManualRequestStore(idx)"
                            />
                            <span class="ls-button-toggle-icon">
                                <i
                                    class="fa"
                                    :class="{
                                        'fa-check-square ls-color--green--color-dodge':
                                            service.value,
                                        'fa-square-o ls-color--gray--light': !service.value,
                                    }"
                                ></i>
                            </span>
                            <span>{{ service.name }}</span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="grid__col-sm-10">
                <label class="ls-label ls-margin--top" for="other-details"
                    >Other details about what you need</label
                >
                <div class="ls-input__wrapper" :class="{ 'ls-padding--right': !screenSize.xs }">
                    <textarea
                        id="other-details"
                        v-model="details"
                        v-ls-track.change="{
                            target: 'manual-request--notes',
                            attachValue: true,
                        }"
                        class="ls-input"
                        type="textbox"
                        rows="3"
                        @input="updateManualRequestStore()"
                    ></textarea>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import _ from 'lodash';
import * as types from '@/store/types';
import lsTrackService from '@/services/ls-track/ls-track.service';
import eventBusService from '@/services/event-bus.service';

export default {
    data() {
        return {
            services: [
                {
                    value: false,
                    name: 'Recurring Mowing',
                    property: 'recurring',
                },
                {
                    value: false,
                    name: 'One-time Mowing',
                    property: 'one-time',
                },
                {
                    value: false,
                    name: 'Cleanups',
                    property: 'clean-up',
                },
                {
                    value: false,
                    name: 'Lawn Treatment',
                    property: 'fertilization',
                },
                {
                    value: false,
                    name: 'Aeration',
                    property: 'aeration',
                },
                {
                    value: false,
                    name: 'Other',
                    property: 'other',
                },
            ],
            details: '',
            mqInvalid: false,
        };
    },
    computed: {
        ...mapState(['manualRequest', 'screenSize']),
    },
    props: {
        preselectedServices: {
            type: Object,
            required: false,
        },
    },
    methods: {
        ...mapActions({
            updateManualRequest: types.MANUAL_REQUEST__UPDATE_MANUAL_REQUEST,
        }),
        updateManualRequestStore(idx) {
            if (_.isNumber(idx)) {
                lsTrackService.track({
                    type: 'change',
                    target: 'manual-request--option',
                    data: {
                        str_id: this.services[idx].property,
                    },
                });
                this.updateManualRequest({
                    services: {
                        [this.services[idx].property]: this.services[idx].value,
                    },
                });
            } else {
                this.updateManualRequest({ details: this.details });
            }
            this.mqInvalid = !this.manualRequest.valid;
        },
    },
    created() {
        if (this.$route.name !== 'outOfMarketForm') {
            this.services[0].replaceCheckbox = true;
        }

        this.details = _.get(this, 'manualRequest.details') || this.details;
        const stateServices = _.get(this, 'manualRequest.services') || {};
        if (!_.isEmpty(stateServices)) {
            _.forEach(this.services, (service) => {
                const selectedService = stateServices[service.property];
                if (selectedService) {
                    // eslint-disable-next-line no-param-reassign
                    service.value = Boolean(selectedService);
                }
            });
        }
    },
    mounted() {
        if (this.preselectedServices) {
            _.forEach(this.services, (service) => {
                const selectedService = _.get(this, `preselectedServices.${service.property}`);
                if (!_.isUndefined(selectedService)) {
                    // eslint-disable-next-line no-param-reassign
                    service.value = this.preselectedServices[service.property];
                    this.updateManualRequest({
                        services: {
                            [service.property]: service.value,
                        },
                    });
                }
            });
        }
        eventBusService.eventBus.$on('submitButtonClick', () => {
            if (!this.manualRequest.valid) {
                this.mqInvalid = true;
            }
        });
    },
};
</script>

<style lang="scss">
.ls-input {
    resize: none;
}

.ls-services__outer-container {
    display: flex;
    flex-wrap: wrap;
}

.ls-services__inner-container {
    flex: 0 0 auto;
    padding-right: rem(0);
    width: 50%;

    @include max-screen(breakpoint(xs, max)) {
        padding-right: 0;
        width: 100%;
    }
}

.ls-manual-request--mq-invalid {
    color: palette(red);
}
</style>
